import { render, staticRenderFns } from "./TaskStatusCard.vue?vue&type=template&id=78631c93&"
import script from "./TaskStatusCard.vue?vue&type=script&lang=js&"
export * from "./TaskStatusCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports